import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Bill } from '../Shared/Bill';
import { formatMoney } from '../Shared/Functions';
import { withToast } from '../Shared/Toast';
import { BillsVService } from '../../services/V2/gozer';
import { getBillingHistory } from '../Shared/ExportsFunctions';
import GetAppIcon from '@mui/icons-material/GetApp';
import { CustomTable } from '../Shared/CustomTable';
import { Link } from 'react-router-dom';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { IsMobile } from '../Shared/Functions';

const BillHistory = ({ account, errorToast }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [active, setActive] = useState<string>("");
    const [showBill, setShowBill] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true)
    }, [account])// eslint-disable-line react-hooks/exhaustive-deps

    const openBill = (billId) => {
        setActive(billId)
        setShowBill(true)
    }

    const handleDownload = async () => {
        var date = new Date()
        await getBillingHistory(account.id, {
                pageNumber: 1,
                orderBy: "CreatedAt",
                orderByDesc: true,
                filters: [{
                    property: "BillingAccountId",
                    value: account.id
                }],
                fromDate: new Date((date).setFullYear(date.getFullYear()-2)).toUTCString()
            })
    }

    return <Grid container>
        {showBill && <Bill show={showBill} hide={() => setShowBill(false)} billingAccountId={account.id} billId={active} fail={errorToast} />}
            <Grid container>
                <Grid xs={12} style={{ padding: "0px 25px" }}>
                    <CustomTable
                        title={"BILLING HISTORY"}
                        refresh={loading}
                        setRefresh={setLoading}
                        columns={[
                            {
                                field: "billDate",
                                title: "Bill Date",
                                editable: 'never',
                                render: params => new Date(params.billingCycle.billDate).toLocaleDateString(),
                                hidden: IsMobile(),
                                sorting: false
                            },
                            {
                                field: "dueDate",
                                title: "Due Date",
                                editable: 'never',
                                render: params => new Date(params.billingCycle.dueDate).toLocaleDateString(),
                                sorting: false
                            },
                            {
                                field: "dueAmount",
                                title: "Amount Due",
                                editable: 'never',
                                render: params => formatMoney(params.dueAmount),
                                sorting: false
                            },
                            {
                                field: "",
                                title: "View Bill",
                                editable: 'never',
                                render: params => <Link to="#" onClick={() => openBill(params.id)} style={{ color: "black" }} aria-label={`View bill for ${new Date(params.billDate ?? 0).toLocaleDateString()}`} title="View bill"><FindInPageIcon /></Link>,
                                sorting: false
                            }
                        ]}
                        dataEndpoint={async query => {
                            let data = await BillsVService.billsVGetPastTwoYears(account.id)
                            setLoading(false)
                            return {
                                data: data ?? [],
                                totalCount: data?.length ?? 0,
                                numberPerPage: 10
                            }
                        }}
                        actions={[
                            {
                                icon: () => <GetAppIcon />,
                                tooltip: "Export",
                                isFreeAction: false,
                                onClick: () => handleDownload()
                            }
                        ]}
                        pageSize={10}
                        onRowClick={null}
                    />
                </Grid>
            </Grid>
        </Grid>
}
export default withToast(BillHistory);